module.exports = __webpack_public_path__ + "img/formsDreieckRW.aba343a5.svg";